import type { MailboxWrite } from './types';

/**
 * Cubas's mail is on Hostinet, and this one server is both ways in: IMAP to read on 993,
 * SMTP to forward on 587. A new mailbox starts with it, and only a superadministrator
 * sees the fields to write over it.
 */
export const HOSTINET_HOST = 'ehost6027.hostinet.com';

/**
 * What «Conectar un buzón nuevo» sends when an administrator of the shop fills it in
 * (Víctor, Ernesto): the address and its password, nothing else to decide.
 *
 * - The address is the name, the address redirects leave from and the login: on
 *   Hostinet they are always the same, so asking twice only invites the `.es`/`.com`
 *   mistake of 2026-09-23.
 * - The server is Hostinet's, both ways.
 * - No `profile`: the back puts its default, and the rules are a superadministrator's to
 *   change from «Editar». No `on_confirm` either: the back's default, «Se ordena».
 */
export function shopMailboxPayload(address: string, password: string): MailboxWrite {
  const email = address.trim().toLowerCase();
  return {
    name: email,
    address: email,
    username: email,
    password,
    host: HOSTINET_HOST,
    port: 993,
    ssl: true,
    folder: 'INBOX',
    smtp_host: HOSTINET_HOST,
    smtp_port: 587,
    smtp_starttls: true,
    enabled: true,
  };
}

/** A full address: something before and after an `@`, a dot in the domain, no spaces. */
export function looksLikeAddress(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
}
